<template>
  <fieldset>
    <div class="mb-3">
      <div class="input-group mb-1">
        <div class="input-group-prepend">
          <div class="input-group-text">Google Conversion ID</div>
        </div>
        <input
          type="text" class="form-control"
          required pattern="^[0-9]+$"
          v-model="tagId" @input="onUpdate">
      </div>
      <p class="small italic">T.ex. <code>11137983405</code></p>
    </div>

    <div class="mb-3">
      <div class="input-group mb-1">
        <div class="input-group-prepend">
          <div class="input-group-text">Google Conversion Label</div>
        </div>
        <input
          type="text" class="form-control"
          required
          v-model="conversionId" @input="onUpdate">
      </div>
      <p class="small italic">T.ex. <code>V_K5CLyn5ZgYEK3HgL8p</code></p>
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const tagId = ref(null);
const conversionId = ref(null);
const serializedValue = computed(() => {
  return {
    tag_id: tagId.value,
    conversion_id: conversionId.value
  };
});
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    tagId.value = modelValue.value.tag_id;
    conversionId.value = modelValue.value.conversion_id;
  }
}, {
  immediate: true
});
</script>
